// TODO(launch): replace APP_STORE_URL with the real App Store listing URL before publishing.
export const APP_STORE_URL = "https://apps.apple.com/app/steth";

export const SUPPORT_EMAIL = "support@stethdating.com";

// Real App Store screenshots supplied by the STETH team
export const SHOTS = {
  welcome: "/assets/screenshots/welcome.webp",
  verified: "/assets/screenshots/verified.webp",
  firstdate: "/assets/screenshots/firstdate.webp",
  chat: "/assets/screenshots/chat.webp",
  onboarding: "/assets/screenshots/onboarding.webp",
};

// Lifestyle photography — members out of uniform, showing real personality
export const LIFESTYLE = [
  {
    src: "https://images.unsplash.com/photo-1714640856321-99a204fe40a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzNDR8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBsYXVnaGluZyUyMGNvZmZlZSUyMGNhZmUlMjB3YXJtJTIwcG9ydHJhaXR8ZW58MHx8fDE3OTA5OTk0NTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Member laughing over coffee",
    tag: "Coffee first",
  },
  {
    src: "https://images.unsplash.com/photo-1744060204728-f68e434a3edf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBydW5uaW5nJTIwb3V0ZG9vcnMlMjBzbWlsaW5nJTIwd2FybSUyMHN1bnNldHxlbnwwfHx8fDE3OTA5OTk0NTJ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Member out for a golden-hour run",
    tag: "5am runner",
  },
  {
    src: "https://images.unsplash.com/photo-1636647511729-6703539ba71f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBjb29raW5nJTIwZm9vZCUyMGtpdGRjaGVuJTIwaG9tZSUyMGNvenklMjB3YXJtfGVufDB8fHx8MTc5MDk5OTQ1Mnww&ixlib=rb-4.1.0&q=85",
    alt: "Member cooking at home",
    tag: "Ramen critic",
  },
  {
    src: "https://images.unsplash.com/photo-1536625979259-edbae645c7c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NzR8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjBoaWtpbmclMjBuYXR1cmUlMjBnb2xkZW4lMjBob3VyJTIwd2FybSUyMGxpZ2h0fGVufDB8fHx8MTc5MDk5OTQ1Mnww&ixlib=rb-4.1.0&q=85",
    alt: "Member hiking a forest trail",
    tag: "Trail regular",
  },
  {
    src: "https://images.unsplash.com/photo-1525201548942-d8732f6617a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBwbGF5aW5nJTIwYWNvdXN0aWMlMjBndWl0YXIlMjB3YXJtJTIwc3VubGlnaHQlMjBjcmVhdGl2ZSUyMGhvYmJ5fGVufDB8fHx8MTc5MDk5OTQ1Mnww&ixlib=rb-4.1.0&q=85",
    alt: "Member playing acoustic guitar",
    tag: "Sunday sessions",
  },
];
